import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({ name: 'appDate' })
export class AppDatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

  transform(
    value: string | Date | number | null | undefined,
    format: string = 'dd/MM/yyyy',
    timezone: string = '-0300'
  ): string | null {
    if (value == null || value === '') {
      return null;
    }

    return formatDate(value, format, this.locale, timezone);
  }
}
